/**
 * Created by Shuhin on 05/16/20.
 */
import React from "react";
import Dialog from "material-ui/Dialog";
import ManualPaymentContainer from "./manual-payment.container";

const styles = {
  root: {},
  customContentStyle: {
    width: "45%",
    height: "60%",
    maxWidth: "none",
    maxHeight: "none",
  },
  actions: {
    marginLeft: "10px",
  },
};

const ManualPaymentDialog = (props) => {
  let {
    open,
    mission,
    toggleManualPaymentDialog,
  } = props;

  return (
    <Dialog
      open={open}
      modal={false}
      autoScrollBodyContent={true}
      bodyStyle={{ height: "100%" }}
      onRequestClose={toggleManualPaymentDialog}
      contentStyle={styles.customContentStyle}
    >
      <ManualPaymentContainer
        mission={mission}
        toggleManualPaymentDialog={toggleManualPaymentDialog}
      />
    </Dialog>
  );
};

export default ManualPaymentDialog;



// WEBPACK FOOTER //
// ./src/screens/pending-payments/manual-payment-dialog.component.js